import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchVendors } from "store/actions/vendorActions";
import { rejectVendor } from "store/actions/vendorActions";
import { approveVendor } from "store/actions/vendorActions";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const Vendors = () => {
  const dispatch = useDispatch();
  const { vendors, hasMore, lastDoc, isFetching, actionLoading } = useSelector(
    (state) => state.vendor
  );

  const [activeTab, setActiveTab] = useState("vendorRequests");
  const [activeVendorId, setActiveVendorId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [vendorsRequestTooltipOpen, setVendorsRequestTooltipOpen] =
    useState(false);
  const [activeVendorsTooltipOpen, setActiveVendorsTooltipOpen] =
    useState(false);

  const toggleVendorsRequestTooltip = () =>
    setVendorsRequestTooltipOpen(!vendorsRequestTooltipOpen);

  const toggleActiveVendorsTooltip = () =>
    setActiveVendorsTooltipOpen(!activeVendorsTooltipOpen);
  const Vendors = vendors?.map((vendor) => ({
    ...vendor,
    updatedAt: new Date(vendor.updatedAt.seconds * 1000).toLocaleDateString(
      "en-US"
    ),
  }));

  const columns = [
    "Name",
    "Email",
    activeTab === "bidRequests" ? "Date of Request" : "Date of Approval",
    "Status",
  ];

  const keyMap = {
    Name: "name",
    Email: "email",
    ...(activeTab === "bidRequests"
      ? { "Date of Request": "updatedAt" }
      : { "Date of Approval": "updatedAt" }),
    Status: "status",
  };
  const vendorsInfoPoints = [
    "  Review vendor registration requests submitted by users.",
    "Evaluate vendor information and eligibility.",
    "Accept or reject vendor registration requests.",
    "Manage the list of active vendors who are approved to post bids on the FHP platform",
  ];
  const subPoints = [
    {
      title: "Vendor Request",
      description:
        "This tab lists all new registration requests from users who wish to become vendors on the FHP platform. The admin reviews these requests and decides whether to approve or reject them.",
    },
    {
      title: "Active Vendors",
      description:
        "Once a vendor request is accepted, the vendor is moved to this tab. It contains a list of all approved vendors who are authorized to create and submit bids.",
    },
  ];
  const vendorsInfoTitle = "Vendors Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const renderActions = (vendor) => (
    <td className="text-center">
      <Button
        color="primary"
        size="sm"
        onClick={() => intiateVendorAction("approve", vendor?.id)}
      >
        Accept
      </Button>
      <Button
        color="danger"
        size="sm"
        onClick={() => intiateVendorAction("reject", vendor?.id)}
      >
        Reject
      </Button>
    </td>
  );

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const confirmationModalToggler = () => {
    if (confirmationModal) {
      handleReset();
    }
    setConfirmationModal(!confirmationModal);
  };

  const handleReset = () => {
    setActionType("");
    setActiveVendorId(null);
  };

  const intiateVendorAction = (type, vendorId) => {
    setActionType(type);
    setActiveVendorId(vendorId);
    confirmationModalToggler();
  };

  const handleVendorAction = () => {
    if (activeVendorId) {
      if (actionType === "approve") {
        dispatch(
          approveVendor({
            vendorId: activeVendorId,
            onSuccess: confirmationModalToggler,
          })
        );
      } else {
        dispatch(
          rejectVendor({
            vendorId: activeVendorId,
            onSuccess: confirmationModalToggler,
          })
        );
      }
    }
  };

  const loadMoreVendors = () => {
    dispatch(fetchVendors(lastDoc, activeTab));
  };

  useEffect(() => {
    dispatch(fetchVendors(null, activeTab));
  }, [activeTab]);

  return (
    <>
      <Header />
      <Container className="mt-2 mb-4" fluid>
        <Card className="shadow overflow-hidden">
          <Nav
            tabs
            className="d-flex justify-content-start text-dark athlete_earning-nav"
          >
            <NavItem>
              <NavLink
                id="VendorsRequestsTooltip"
                className={
                  activeTab === "vendorRequests"
                    ? "active active-tab py-2 bg-primary "
                    : "text-dark cursor-pointer py-2 "
                }
                onClick={() => toggleTab("vendorRequests")}
              >
                <h2
                  className={activeTab === "vendorRequests" && "text-white"}
                  onClick={() => toggleTab("vendorRequests")}
                >
                  Vendor Requests
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                id="ActiveVendorsTooltip"
                className={
                  activeTab === "activeVendors"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => toggleTab("activeVendors")}
              >
                <h2 className={activeTab === "activeVendors" && "text-white"}>
                  Active Vendors
                </h2>
              </NavLink>
            </NavItem>
            <h2
              className="mb-0 ml-auto m-2 text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => setInfoModalOpen(true)}
            >
              <i className="fa fa-question-circle" aria-hidden="true"></i>
            </h2>{" "}
          </Nav>
          <TabContent
            activeTab={activeTab}
            className="p-3 athlete-earning-content"
          >
            <TabPane tabId="vendorRequests">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <TableComponent
                  columns={columns}
                  data={Vendors}
                  keyMap={keyMap}
                  renderActions={renderActions}
                />
              )}
            </TabPane>
            <TabPane tabId="activeVendors">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <TableComponent
                  columns={columns}
                  data={Vendors}
                  keyMap={keyMap}
                />
              )}
            </TabPane>
          </TabContent>
          {hasMore && (
            <div className="d-flex justify-content-center py-4">
              <Button
                color="primary"
                onClick={loadMoreVendors}
                disabled={isFetching}
              >
                Load More
              </Button>
            </div>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={vendorsInfoPoints}
        title={vendorsInfoTitle}
        subPoints={subPoints}
      />
      <Modal
        isOpen={confirmationModal}
        toggle={confirmationModalToggler}
        centered
      >
        <ModalBody>
          <div className="d-flex align-items-center flex-column text-center">
            {/* <svg
              width={128}
              height={128}
              viewBox="-0.5 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M10.8809 16.15C10.8809 16.0021 10.9101 15.8556 10.967 15.7191C11.024 15.5825 11.1073 15.4586 11.2124 15.3545C11.3175 15.2504 11.4422 15.1681 11.5792 15.1124C11.7163 15.0567 11.8629 15.0287 12.0109 15.03C12.2291 15.034 12.4413 15.1021 12.621 15.226C12.8006 15.3499 12.9399 15.5241 13.0211 15.7266C13.1024 15.9292 13.122 16.1512 13.0778 16.3649C13.0335 16.5786 12.9272 16.7745 12.7722 16.9282C12.6172 17.0818 12.4204 17.1863 12.2063 17.2287C11.9922 17.2711 11.7703 17.2494 11.5685 17.1663C11.3666 17.0833 11.1938 16.9426 11.0715 16.7618C10.9492 16.5811 10.8829 16.3683 10.8809 16.15ZM11.2408 13.42L11.1008 8.20001C11.0875 8.07453 11.1008 7.94766 11.1398 7.82764C11.1787 7.70761 11.2424 7.5971 11.3268 7.5033C11.4112 7.40949 11.5144 7.33449 11.6296 7.28314C11.7449 7.2318 11.8697 7.20526 11.9958 7.20526C12.122 7.20526 12.2468 7.2318 12.3621 7.28314C12.4773 7.33449 12.5805 7.40949 12.6649 7.5033C12.7493 7.5971 12.813 7.70761 12.8519 7.82764C12.8909 7.94766 12.9042 8.07453 12.8909 8.20001L12.7609 13.42C12.7609 13.6215 12.6809 13.8149 12.5383 13.9574C12.3958 14.0999 12.2024 14.18 12.0009 14.18C11.7993 14.18 11.606 14.0999 11.4635 13.9574C11.321 13.8149 11.2408 13.6215 11.2408 13.42Z"
                  fill="#fbc02d"
                ></path>{" "}
                <path
                  d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                  stroke="#fbc02d"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
              </g>
            </svg> */}
            <span className="mt-2" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            Are you sure you want to{" "}
            {actionType === "approve" ? "approve" : "reject"} this vendor?
            <div className="d-flex my-4">
              <Button
                color="primary"
                onClick={handleVendorAction}
                disabled={
                  actionType === "approve" ? actionLoading : actionLoading
                }
              >
                Yes
                {(actionType === "approve" ? actionLoading : actionLoading) && (
                  <Spinner color="white" size="sm" className="ml-2" />
                )}
              </Button>
              <Button
                color="danger"
                className="me-3"
                onClick={confirmationModalToggler}
              >
                No
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Vendors;
